import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedKiloClassCoachRoleList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseClassCoachRoles {
  limit?: string;
}

function useClassCoachRoles({
  limit = '20',
}: IUseClassCoachRoles): UseInfiniteQueryResult<AxiosResponse<PaginatedKiloClassCoachRoleList>> {
  const fetchClassCoachRoles = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedKiloClassCoachRoleList>> => {
    const params = pageParam;
    return client.get(`kilo-class-coach-roles/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['classCoachRoles'], fetchClassCoachRoles, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useClassCoachRoles;
